export const vibhava = {
  slug: "vibhava",
  name: "Vibhava",
  location: "Thirumalapur, Balanagar",
  approval: "MUDA approved layout",
  acreage: "78 acres",
  status: "Open for enquiries",
  logo: "/projects/vibhava/logo.png",
  hero: "/projects/vibhava/vibhava-top-view-representation-18.webp",
  summary:
    "Residential plots with premium planning, strong highway access, and long-term growth potential near the Bangalore Highway and RRR corridor.",
  description:
    "Vibhava is best presented through scale, road formation, earthwork, and visible site development, showing buyers that this is an active plotted community taking shape.",
  layoutImages: [{ src: "/projects/layouts/vibhava-layout.webp", alt: "Vibhava layout preview", label: "Layout preview" }],
  approvalImages: [],
  featuredImages: [
    {
      src: "/projects/vibhava/sunset-aerial.webp",
      alt: "Vibhava sunset aerial view",
      title: "Growth-corridor scale",
      copy: "Aerial imagery communicates the project footprint and surrounding land context more clearly than a generic visual."
    },
    {
      src: "/projects/vibhava/road-machinery.webp",
      alt: "Vibhava road machinery work",
      title: "Active site development",
      copy: "Machinery, roadwork, and drainage visuals make the development story credible for serious plot buyers."
    },
    {
      src: "/projects/vibhava/site-building.webp",
      alt: "Vibhava site building and water tower",
      title: "On-ground infrastructure",
      copy: "Site structures and utilities help move the page from promise to evidence."
    }
  ],
  galleryImages: [
    ["/projects/vibhava/sunset-aerial.webp", "Sunset aerial view"],
    ["/projects/vibhava/aerial-layout.webp", "Aerial layout and approach road"],
    ["/projects/vibhava/clubhouse-aerial.webp", "Site building and plotted area"],
    ["/projects/vibhava/earthwork.webp", "Earthwork in progress"],
    ["/projects/vibhava/plot-marking.webp", "Plot marking on site"],
    ["/projects/vibhava/roadwork.webp", "Road formation work"],
    ["/projects/vibhava/site-building.webp", "Site building and water tower"],
    ["/projects/vibhava/road-machinery.webp", "Road work with machinery"],
    ["/projects/vibhava/drainage-work.webp", "Drainage and stonework"],
    ["/projects/vibhava/flagged-road.webp", "Flagged internal road"]
  ],
  facts: [["Approval", "MUDA"], ["Extent", "78 acres"], ["Use", "Residential plots"], ["Corridor", "Bangalore Highway"]],
  amenities: ["Wide internal roads", "Parks and green zones", "Entrance feature", "Street lighting", "Planned utilities"]
};
